import React from 'react';
import cn from 'classnames';
import './Loader.css';

/**
 * The ONE loader used across the whole app (inline / overlay / fullscreen).
 * A newspaper-inspired animation: a stack of "pages" with a scan line sweeping
 * across them. There is no circle/ring spinner anywhere else in the project so
 * the loading visual is always identical.
 */
const NewspaperMark = ({ large }) => (
  <span className={cn('kvo-newsloader', { 'kvo-newsloader--lg': large })} aria-hidden="true">
    <span className="kvo-newsloader__stack">
      <span className="kvo-newsloader__page" />
      <span className="kvo-newsloader__page" />
      <span className="kvo-newsloader__page">
        <span className="kvo-newsloader__line" />
        <span className="kvo-newsloader__line" />
        <span className="kvo-newsloader__line" />
      </span>
      <span className="kvo-newsloader__scan" />
    </span>
  </span>
);

const Loader = ({ label, fullscreen = false, overlay = false, className }) => {
  const content = (
    <>
      <NewspaperMark large={fullscreen} />
      {label && <span className="kvo-loader__label">{label}</span>}
    </>
  );

  if (fullscreen) {
    return (
      <div className={cn('kvo-loader kvo-loader--fullscreen', className)} role="status" aria-live="polite">
        {content}
      </div>
    );
  }
  if (overlay) {
    return (
      <div className={cn('kvo-loader kvo-loader--overlay', className)} role="status" aria-live="polite">
        {content}
      </div>
    );
  }
  return (
    <span className={cn('kvo-loader kvo-loader--inline', className)} role="status" aria-live="polite">
      {content}
    </span>
  );
};

export default Loader;
